import React from 'react';
import PropTypes from 'prop-types';
import differenceInMonths from 'date-fns/difference_in_months';
import differenceInYears from 'date-fns/difference_in_years';
import format from 'date-fns/format';
import { startCase } from 'lodash';
import styled from 'styled-components';
import { formatAddress } from '../../../util/helpers';
import { Text } from '../../common';

const DetailsHeading = styled.h4`
  margin: 0;
`;

const Wrapper = styled.div`
  margin-bottom: 1em;
`;
const Warn = styled.h4`
  color: #f00;
`;

function getAgeDetails(birthday) {
  const now = new Date();
  const ageInYears = differenceInYears(now, birthday);

  if (Math.abs(ageInYears) > 0) return ageInYears;

  const ageInMonths = differenceInMonths(now, birthday);
  const monthDisplay = ageInMonths === 1 ? 'month' : 'months';
  return `${ageInMonths} ${monthDisplay}`;
}

function ChildDetails({
  addressState,
  birthday,
  city,
  firstName,
  gender,
  lastName,
  secondaryStreetAddress,
  additionalNotes,
  streetAddress,
  zipCode,
  notes,
}) {
  const dateOfBirth = format(birthday, 'M/D/YYYY');
  return (
    <Wrapper>
      <DetailsHeading>{`${firstName} ${lastName}`}</DetailsHeading>
      <div>{startCase(gender)}</div>
      <div>{`Age: ${getAgeDetails(birthday)}`}</div>
      <div>{`DOB: ${dateOfBirth}`}</div>
      <div>{streetAddress}</div>
      <div>{secondaryStreetAddress}</div>
      <div>{formatAddress(city, addressState, zipCode)}</div>
      <Warn>IMPORTANT! - Special Care Concerns</Warn>
      <div>{additionalNotes}</div>
      {notes && (
        <div>
          <Text>Notes: </Text>
          <Text>{notes}</Text>
        </div>
      )}
    </Wrapper>
  );
}

ChildDetails.propTypes = {
  addressState: PropTypes.string.isRequired,
  birthday: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  gender: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  streetAddress: PropTypes.string.isRequired,
  zipCode: PropTypes.string.isRequired,
  additionalNotes: PropTypes.string,
  notes: PropTypes.string,
  secondaryStreetAddress: PropTypes.string,
};

ChildDetails.defaultProps = {
  secondaryStreetAddress: '',
};

export default ChildDetails;



// WEBPACK FOOTER //
// ./src/modules/ChildInformationPage/components/ChildDetails.js